import React, { useEffect, useState } from 'react';
import {
    Bouton,
    InputMi,
    Lien,
    Checkbox,
    Row,
    Col,
    Container,
} from '@design-system-etat/dsfr-react';
import { useForm, FormProvider } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import DateDeNaissanceInput from 'components/Commun/Form/Date/DateDeNaissanceInput';
import DateInput from 'components/Commun/Form/Date/DateInput';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import { getMessageErreurChampManquant, comparerDeuxDates } from 'utils/utils';
import {
    API_DEMANDE_ARME_HERITEE_URL,
    API_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA,
    CONTEXT_DEMANDE_ARME_HERITEE,
    CONTEXT_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA,
} from 'constants/apiUrls.constants';
import usagerClientReducer from 'store/usagerReducer';
import { REGEX_RGA } from 'constants/contraintes.constants';
import RoutesRatelier from '../../ratelier/routes';
import formaterDemandeArmeHeritee from './components/FormaterDemandeArmeHeritee';
import ModaleArme from '../../../../components/arme/modaleAjoutArme/ModaleArme';
import { getPath } from '../../../../utils/router';

const DemandeArmeHeritee = ({
    postApi,
    getApi,
    reinitialiseApi,
    erreurDemandeArmeHeritee,
    isLoadingDemandeArmeHeritee,
    messageDemandeArmeHeritee,
    erreurGdr,
}) => {
    const hookForm = useForm();
    const { register, handleSubmit, formState, watch, getValues, setError, clearErrors } = hookForm;

    const { REACT_APP_RGA_URL } = process.env;

    const history = useHistory();

    const redirectionToRatelier = () => {
        history.push(getPath(RoutesRatelier));
    };

    const isNumeroEncodageRequired = () => {
        return !(watch('numeroRga') && (watch('numeroCarcasse') || watch('hasNumeroSerie')));
    };

    const isValidDateDeces = () => {
        const dateNaissancePersonneDecedee = getValues('dateNaissancePersonneDecedee');
        const dateDecesPersonneDecedee = getValues('dateDecesPersonneDecedee');
        if (dateNaissancePersonneDecedee && dateDecesPersonneDecedee) {
            return comparerDeuxDates(dateDecesPersonneDecedee, dateNaissancePersonneDecedee);
        }

        return true;
    };

    const isValidNumeroRga = () => {
        return !('numeroRga' in formState.errors);
    };

    const isFormulaireValide = () => {
        return (
            watch('nomPersonneDecedee') &&
            watch('prenomPersonneDecedee') &&
            watch('dateNaissancePersonneDecedee') &&
            watch('lieuNaissancePersonneDecedee') &&
            (watch('numeroEncodage') ||
                (watch('numeroRga') && (watch('numeroCarcasse') || watch('hasNumeroSerie')))) &&
            isValidDateDeces() &&
            isValidNumeroRga()
        );
    };

    const afficherErreurGdr = () => {
        setError('numeroRga', {
            type: 'manual',
            message: `Le format est incorrect`,
        });
    };

    useEffect(() => {
        const numeroRga = getValues('numeroRga');
        const regexRGA = new RegExp(REGEX_RGA);

        if (watch('numeroRga')) {
            if (regexRGA.test(numeroRga)) {
                getApi(
                    usagerClientReducer,
                    API_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA + numeroRga,
                    CONTEXT_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA,
                );
            } else {
                afficherErreurGdr();
            }
        } else {
            clearErrors('numeroRga');
        }
    }, [watch('numeroRga')]);

    useEffect(() => {
        if (erreurGdr === false) {
            clearErrors('numeroRga');
        } else {
            afficherErreurGdr();
        }
    }, [erreurGdr]);

    useEffect(() => {
        if (watch('numeroEncodage')) {
            if (erreurDemandeArmeHeritee === true || erreurDemandeArmeHeritee === null) {
                // vérifier si le message d'erreur concerne  numeroEncodage :(
                if (
                    messageDemandeArmeHeritee &&
                    messageDemandeArmeHeritee.search(getValues('numeroEncodage')) !== -1
                ) {
                    setError('numeroEncodage', {
                        type: 'manual',
                        message: `Le numéro d'encodage "${getValues(
                            'numeroEncodage',
                        )}" est non valide. Veuillez saisir un numéro d'encodage valide`,
                    });
                }
            }
        } else {
            clearErrors('numeroEncodage');
        }
    }, [erreurDemandeArmeHeritee, isLoadingDemandeArmeHeritee, watch('numeroEncodage')]);

    useEffect(() => {
        if (!erreurDemandeArmeHeritee && isLoadingDemandeArmeHeritee === false) {
            reinitialiseApi(CONTEXT_DEMANDE_ARME_HERITEE);
        }
    }, [isLoadingDemandeArmeHeritee, erreurDemandeArmeHeritee]);

    const onSubmit = (dataForm) => {
        if (dataForm && isFormulaireValide()) {
            const dataFormat = formaterDemandeArmeHeritee(dataForm);

            reinitialiseApi(CONTEXT_DEMANDE_ARME_HERITEE);
            postApi(
                usagerClientReducer,
                API_DEMANDE_ARME_HERITEE_URL,
                dataFormat,
                CONTEXT_DEMANDE_ARME_HERITEE,
            );
        }
    };

    const [modaleOuverte, setModaleOuverte] = useState(false);

    return (
        <Container>
            <ModaleArme
                message="héritée"
                modaleOuverte={modaleOuverte}
                onClickFunction={redirectionToRatelier}
            />
            <Row>
                <Col col={12}>
                    <h1>
                        Renseigner les informations sur les circonstances de la mise en possession :
                    </h1>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <h2>Informations sur la personne décédée : </h2>
                </Col>
            </Row>
            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row goutierre>
                        <Col col={12} lg={6}>
                            <InputMi
                                label="Nom"
                                uppercase
                                {...register('nomPersonneDecedee', {
                                    required: getMessageErreurChampManquant('nomPersonneDecedee'),
                                })}
                                error={
                                    formState.errors ? formState.errors.nomPersonneDecedee : null
                                }
                                required
                            />
                        </Col>
                    </Row>
                    <Row goutierre>
                        <Col col={12} lg={6}>
                            <InputMi
                                label="Prénom"
                                uppercase
                                {...register('prenomPersonneDecedee', {
                                    required:
                                        getMessageErreurChampManquant('prenomPersonneDecedee'),
                                })}
                                error={
                                    formState.errors ? formState.errors.prenomPersonneDecedee : null
                                }
                                required
                            />
                        </Col>
                    </Row>
                    <Row goutierre>
                        <Col col={12} lg={3}>
                            <DateDeNaissanceInput
                                label="Date de naissance"
                                name="dateNaissancePersonneDecedee"
                                required
                                noFuture
                                avant1900
                            />
                        </Col>
                    </Row>
                    <Row goutierre>
                        <Col col={12} lg={6}>
                            <InputMi
                                label="Commune/lieu dit de naissance"
                                uppercase
                                {...register('lieuNaissancePersonneDecedee', {
                                    required: getMessageErreurChampManquant(
                                        'lieuNaissancePersonneDecedee',
                                    ),
                                })}
                                error={
                                    formState.errors
                                        ? formState.errors.lieuNaissancePersonneDecedee
                                        : null
                                }
                                required
                            />
                        </Col>
                    </Row>
                    <Row goutierre>
                        <Col col={12} lg={3}>
                            <DateInput
                                label="Date de décès"
                                name="dateDecesPersonneDecedee"
                                validate={{
                                    isValidDateDeces: () => {
                                        return !isValidDateDeces()
                                            ? 'Veuillez renseigner une date de naissance antérieure à la date de décès'
                                            : null;
                                    },
                                }}
                                noFuture
                            />
                        </Col>
                    </Row>
                    <Row goutierre>
                        <Col col={12} lg={6}>
                            <InputMi
                                label="Numéro SIA (le cas écheant)"
                                uppercase
                                {...register('numeroSiaPersonneDecedee')}
                                error={
                                    formState.errors
                                        ? formState.errors.numeroSiaPersonneDecedee
                                        : null
                                }
                            />
                        </Col>
                    </Row>
                    <Row className="margin-top-md">
                        <Col col={12}>
                            <h2>Renseigner les informations sur l&apos;arme héritée : </h2>
                        </Col>
                    </Row>
                    <Row goutierre>
                        <Col col={12} lg={6}>
                            <InputMi
                                label="Numéro d'encodage (Disponible si l'arme a déjà été enregistrée par un armurier)"
                                uppercase
                                {...register('numeroEncodage', {
                                    required: isNumeroEncodageRequired(),
                                })}
                                error={formState.errors ? formState.errors.numeroEncodage : null}
                            />
                        </Col>
                    </Row>
                    <Row className="margin-top-md">
                        <Col col={12}>
                            <strong>OU</strong>
                        </Col>
                    </Row>
                    <Row goutierre alignementVertical="bottom">
                        <Col col={12} lg={6}>
                            <InputMi
                                label="Numéro RGA"
                                name="numeroRga"
                                type="text"
                                maxLength="5"
                                uppercase
                                {...register('numeroRga', {
                                    required: !watch('numeroEncodage'),
                                })}
                                error={formState.errors ? formState.errors.numeroRga : null}
                                required={!watch('numeroEncodage')}
                            />
                        </Col>
                        <Col col={12} md={6}>
                            <Lien
                                href={REACT_APP_RGA_URL}
                                icone="fr-fi-arrow-right-line"
                                target="_blank"
                            >
                                Rechercher le code correspondant au modèle de mon arme sur le RGA
                            </Lien>
                        </Col>
                    </Row>
                    <Row className="margin-top-md">
                        <Col col={12}>
                            <strong>Et</strong>
                        </Col>
                    </Row>
                    <Row goutierre alignementVertical="bottom">
                        <Col col={12} lg={6}>
                            <InputMi
                                label="Numéro de série"
                                uppercase
                                {...register('numeroCarcasse', {
                                    required: !watch('numeroEncodage') && !watch('hasNumeroSerie'),
                                })}
                                error={formState.errors ? formState.errors.numeroCarcasse : null}
                                displayRequired={
                                    !watch('numeroEncodage') && !watch('hasNumeroSerie')
                                }
                                required={!watch('numeroEncodage') && !watch('hasNumeroSerie')}
                                disabled={watch('hasNumeroSerie')}
                            />
                        </Col>
                        <Col col={12} md={6}>
                            <Checkbox
                                name="hasNumeroSerie"
                                label="Cocher cette case si vous ne parvenez pas à identifier le numéro de série de l'arme"
                                value={false}
                                {...register('hasNumeroSerie')}
                                disabled={watch('numeroCarcasse')}
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row goutierre>
                        <Col col={12}>
                            <Checkbox
                                name="armeIsNeutralisee"
                                label="Cocher cette case si votre arme est neutralisée"
                                {...register('armeIsNeutralisee')}
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row goutierre className="margin-top-lg">
                        <Col lg={6}>
                            <Bouton
                                name="Annuler"
                                label="Annuler"
                                niveau="secondaire"
                                onClick={redirectionToRatelier}
                            />
                        </Col>
                        <Col lg={6} className="text-right">
                            <Bouton
                                name="envoyer"
                                label="Envoyer"
                                type="submit"
                                niveau="primaire"
                                isLoading={isLoadingDemandeArmeHeritee}
                                disabled={!isFormulaireValide()}
                                onClick={() => setModaleOuverte(true)}
                            />
                        </Col>
                    </Row>
                </form>
            </FormProvider>
        </Container>
    );
};

DemandeArmeHeritee.propTypes = {
    postApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    erreurDemandeArmeHeritee: PropTypes.bool,
    isLoadingDemandeArmeHeritee: PropTypes.bool,
    messageDemandeArmeHeritee: PropTypes.string,
    erreurGdr: PropTypes.string,
};

export default connect(
    (state) => {
        const {
            erreur: erreurDemandeArmeHeritee,
            isLoading: isLoadingDemandeArmeHeritee,
            message: messageDemandeArmeHeritee,
        } = state.armes.demandeArmeTrouveeHeritee.demandeArmeHeritee;

        const { erreur: erreurGdr } = state.armes.recupererGdrParNumeroRga;

        return {
            erreurDemandeArmeHeritee,
            isLoadingDemandeArmeHeritee,
            messageDemandeArmeHeritee,
            erreurGdr,
        };
    },
    {
        postApi: postAPI,
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(DemandeArmeHeritee);
